/**
 * 
 */
export default class {

    //
    static appends = [

    ]

    //
    static includes = [

    ]

    //
    static model = null
    
    /**
     * 
     */
    static async create ( data ) {

        //
        const Model = this.model

        //
        try {

            //
            const newModel = new Model( data )
                , response = await newModel.save()
            
            //
            return response.data
        } catch ( error ) {

            //
            return error.response.data
        }
    }

    /**
     * 
     */
    static async delete ( id ) {

        //
        const Model = this.model

        //
        try {

            //
            const currModel = await Model.find( id )
                , response  = await currModel.delete()
            
            //
            return response.data
        } catch ( error ) {

            //
            return error.response.data
        }
    }

    /**
     * 
     */
    static async fetchAll () {

        //
        try {

            //
            const response = await this.modeler().get()
            
            //
            return response.data
        } catch ( error ) {

            //
            return error.response.data
        }
    }

    /**
     * 
     */
    static async fetchById ( id ) {

        //
        try {

            //
            const response = await this.modeler().find( id )
            
            //
            return response
        } catch ( error ) {

            //
            return error.response
        }
    }

    /**
     * 
     */
    static async fetchDataTable ( limit, page, sort, params ) {

        //
        try {

            //
            return ( await this.modeler().limit( limit || 10 ).page( page || 1 ).orderBy( sort ).params( params || {} ).get() )
        } catch ( error ) {
            
            //
            return []
        }
    }
    
    /**
     * 
     */
    static modeler () {
        return this.model.append( this.appends ).include( this.includes )
    }

    /**
     * 
     */
    static async update ( id, data ) {

        //
        const Model = this.model

        //
        try {

            //
            const curModel = await Model.find( id )
                , response = await curModel.sync( data )
            
            //
            return response.data
        } catch ( error ) {

            //
            return error.response.data
        }
    }
}